import { ReactNode } from "react";

import { Footer } from "./components/Footer/Footer";
import { Head, SEOProps } from "./components/Head";
import { Header, HeaderProps } from "./components/Header/Header";

type BaseLayoutProps = {
  seo: SEOProps;
  header: HeaderProps;
  children: ReactNode;
  footer?: boolean;
};

export const BaseLayout = ({
  seo,
  header,
  children,
  footer,
}: BaseLayoutProps) => (
  <>
    <Head {...seo} />
    <Header {...header} />
    {children}
    {footer && <Footer />}
  </>
);
